<template>
	<div class="notification-box" :class="$store.state.app.native ? 'native' : 'desktop'"
	     @touchstart="touchStart"
	     @touchmove="touchMove"
	     @touchend="touchEnd">
		<div class="notification-part"
		     ref="notificationPart"
		     :class="translateX === 0 ? 'transition-class' : ''"
		     :style="{ transform: `translateX(${translatePercent})` }">
			<div class="top-panel">
				<small class="category" v-if="data.category">{{ data.category }}</small>
				<small class="category" v-else>{{ $t('notifications.notification') }}</small>
				<small class="datetime">{{ formattedDate }}</small>
			</div>
			<div class="content">
				<div class="text-image">
					<figure class="fit-image image" v-if="data.image">
						<img :src="data.image">
					</figure>
					<div class="text">
						<h4 class="notification-title">{{ data.name }}</h4>
						<p v-if="data.content">{{ data.content }}</p>
					</div>
				</div>
				<div class="info" v-if="data.price">
					<p class="price" v-if="data.price">{{ data.price }}</p>
				</div>
			</div>
			<div class="actions" v-if="action">
				<button class="button style-1" :class="buttonLoading ? 'loading': ''" v-if="data.type === 'protocol'"
				        @click.stop.prevent="signProtocol">
					<span class="inner">{{ $t('protocols.sign_protocol') }}</span>
				</button>
				<button class="button style-1" :class="buttonLoading ? 'loading': ''"
				        v-else-if="data.type === 'document'" @click.stop.prevent="showDocument">
					<span class="inner">{{ $t('documents.show_document') }}</span>
				</button>
				<button class="button style-1" :class="buttonLoading ? 'loading': ''"
				        v-else-if="data.type === 'article'" @click.stop.prevent="showArticle">
					<span class="inner" v-if="data.button">{{ data.button }}</span>
					<span class="inner" v-else>{{ $t('articles.show_article') }}</span>
				</button>
			</div>
		</div>
		<button class="remove-item mark-as-read" :class="readLoading ? 'loading' : ''"
		        :style="removeItemStyles"
		        @click.prevent.stop="read">
			<i class="fa-regular fa-trash-can" v-if="!readLoading"></i>
			<i class="fa-regular fa-spinner-third" v-else></i>
		</button>
	</div>
</template>

<script>
import i18n from "@/i18n";

export default {
	name: "NotificationBox",
	props: ['data'],
	data() {
		return {
			buttonLoading: false,
			readLoading: false,
			actionTypes: [
				'protocol',
				'document',
				'article'
			],
			startX: 0,
			currentX: 0,
			translateX: 0,
		}
	},
	computed: {
		removeItemStyles() {
			if(!this.$store.state.app.native){
				return {};
			}

			return {
				transform: `translateX(-100%)`,
				minWidth: `${this.translateX * -1}%`
			}
		},
		translatePercent() {
			return `${this.translateX}%`;
		},
		action() {
			return this.actionTypes.includes(this.data.type);
		},
		formattedDate() {
			return this.$moment(this.data.created_at).format('DD.MM.YYYY H:mm:ss');
		}
	},
	methods: {
		touchStart(event) {
			if(!this.$store.state.app.native){
				return;
			}
			this.startX = event.touches[0].clientX;
		},
		touchMove(event) {
			if(!this.$store.state.app.native){
				return;
			}
			this.currentX = event.touches[0].clientX;
			let diff = this.startX - this.currentX;
			let width = this.$refs.notificationPart.offsetWidth;

			let percentage = (diff / width) * 100;

			if (percentage > 0) {
				this.translateX = (1 + percentage) * -1;
			} else {
				this.translateX = 0;
			}
		},
		touchEnd() {
			if(!this.$store.state.app.native){
				return;
			}
			let absTranslate = Math.abs(this.translateX);

			if (absTranslate > 40) {
				this.translateX = -100;
				this.read();
			} else if (absTranslate > 10) {
				this.translateX = -20;
			} else {
				this.translateX = 0;
			}
		},
		showArticle() {
			let id = this.data.data;
			if (!id || this.buttonLoading) {
				return false;
			}

			this.buttonLoading = true;
			this.$store.dispatch('closeSidebars');
			if (this.$route.path !== `${i18n.t('routes.articles.path')}/${id}`) {
				this.$router.push(`${i18n.t('routes.articles.path')}/${id}`);
			}
			this.buttonLoading = false;
			//this.read();
		},
		showDocument() {
			let id = this.data.data;
			if (!id || this.buttonLoading) {
				return false;
			}

			this.buttonLoading = true;
			let promises = [];
			if (!this.$store.state.views.document_categories.length) {
				let documentCategoriesPromise = this.axios.get(`/api/document-categories`);
				promises.push(documentCategoriesPromise);
			}

			let documentPromise = this.axios.get(`/api/documents/${id}`);
			promises.push(documentPromise);

			this.$store.commit('SET_APP_LOADING');
			Promise.all(promises).then((values) => {
				values.forEach(response => {
					if (response.data.document_categories) {
						this.$store.dispatch('setDocumentCategories', response.data.document_categories);
					}
					if (response.data.document) {
						this.$store.dispatch('closeSidebars');
						this.$store.commit('SET_BACK_TO_NOTIFICATIONS', true);
						this.$store.commit('SHOW_DOCUMENTS_EDIT_FORM', response.data.document);
					}
					this.$store.commit('UNSET_APP_LOADING');
					this.buttonLoading = false;
				});
			}).catch(() => {
				this.buttonLoading = false;
				this.$store.commit('UNSET_APP_LOADING');
				this.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: this.$t('general.default_error')
				});
			});
		},
		signProtocol() {
			let hash = this.data.data;
			if (!hash || this.buttonLoading) {
				return false;
			}

			this.$store.commit('SET_APP_LOADING');
			this.buttonLoading = true;
			this.axios.get(`/api/protocols/${hash}`).then(response => {
				this.$store.commit('UNSET_APP_LOADING');
				this.$store.dispatch('closeSidebars');

				let protocol = response.data.protocol[0];
				protocol.hash = protocol.externe_dok_id;
				protocol.files = [];
				response.data.protocol.forEach(item => {
					protocol.files.push({
						name: item.typ_dokumentu,
						type: item.typ_dokumentu_id,
						url: item.url_dokumentu
					});
				});

				this.buttonLoading = false;
				this.$store.commit('SET_BACK_TO_NOTIFICATIONS', true);
				this.$store.commit('SHOW_PROTOCOL_DETAIL', protocol);
			}).catch((error) => {
				this.buttonLoading = false;
				this.$store.commit('UNSET_APP_LOADING');
				if(error.response.data.intranet_id){
					this.$swal.fire({
						icon: 'error',
						title: 'Oops',
						text: error.response.data.message,
						showConfirmButton: true,
						confirmButtonText: this.$t('general.switch_client'),
						showCancelButton: true,
						cancelButtonText: this.$t('forms.cancel'),
					}).then((data) => {
						if (!data.isConfirmed){
							return;
						}
						this.$store.dispatch('closeSidebars');
						this.$root.$emit('switch-client', error.response.data.intranet_id);
					});
					return;
				}

				this.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: this.$t('general.default_error')
				});
			});
		},
		read() {
			this.readLoading = true;

			let url = '/api/notification/read';
			if (this.data.global) {
				url = '/api/notification/read-global';
			}

			this.axios.put(url, {
				id: this.data.id
			}).then(() => {
				this.$store.commit('REMOVE_NOTIFICATION', this.data.id);
				this.readLoading = false;
			}).catch(error => {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: error.response.data.message
				});
				this.readLoading = false;
			})
		}
	}
}
</script>

<style scoped lang="scss">
.percentage {
	text-align: right;
}

.light-mode {
	.notification-title,
	.category,
	.datetime {
		color: var(--background-color, $backgroundColor);
	}

	.top-panel {
		border-bottom: 1px solid rgba(var(--background-color-rgb), 0.15);
	}

	.notification-box {
		background: #F0F0F2;
		background: var(--white-color, $whiteColor);

		.remove-item {
			border-color: var(--white-color, $whiteColor);
			background: var(--background-color, $backgroundColor);
			color: var(--white-color, $whiteColor);
		}
	}
}

.notification-box {
	background: transparentize($whiteColor, .94);
	border-radius: 5px;
	position: relative;

	&.desktop {
		.remove-item {
			background: var(--white-color, $whiteColor);
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 100%;
			width: 38px;
			height: 38px;
			font-size: 14px;
			border: 5px solid var(--background-color, $backgroundColor);
			color: var(--primary-color, $primaryColor);
			cursor: pointer;
			transition: $animationDefaultDuration;
			position: absolute;
			right: -19px;
			top: -19px;
			opacity: 0;
			pointer-events: none;

			&:hover {
				color: var(--white-color, $whiteColor);
				background: var(--primary-color, $primaryColor);
			}
		}

		&:before {
			content: '';
			display: block;
			position: absolute;
			top: -4px;
			right: -4px;
			bottom: -4px;
			left: -4px;
			pointer-events: none;
			border: 2px solid var(--secondary-color, $primaryColor);
			border-radius: 8px;
			opacity: 0;
			transition: $animationDefaultDuration;
		}

		&:hover {
			.remove-item {
				opacity: 1;
				pointer-events: auto;
			}

			&:before {
				opacity: 1;
			}
		}
	}

	&.native {
		overflow: hidden;
		.remove-item {
			background:$errorColor;
			font-size: 24px;
			&:hover {
				background: var(--white-color, $whiteColor);
				color: var(--black-color, $blackColor);
			}
		}

		display: flex;

		.notification-part {
			overflow: hidden;
			width: 100%;
			min-width: 100%;
			.remove-item {
				min-width: 0;
				transition: $animationDefaultDuration;

			}
			&.transition-class {
				transition: $animationDefaultDuration;

			}

		}

	}


	.notification-part {
		padding: 15px;

		> .actions {
			margin-top: 10px;

			.button {
				width: 100%;
				padding: 9px 25px;
				font-size: 12px;
			}
		}
	}

}


.mark-as-read {
	cursor: pointer;
	background: transparent;
	color: var(--font-color, $fontColor);
	border: none;
	padding: 0;
	line-height: 1;
	font-size: 12px;

	&:hover {
		color: var(--white-color, $whiteColor);
	}

	&.loading {
		font-size: 12px;
		line-height: 1;
		color: $whiteColor;
		i {
			animation: spinning_animation 1s infinite;
			animation-timing-function: linear;
		}

	}
}

.top-panel {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 10px;
	//border-bottom: 1px solid transparentize($whiteColor, .85);
	border-bottom: 1px solid rgba(var(--white-color-rgb), .15);
}

.category,
.datetime {
	font-size: 10px;
	color: var(--white-color, $whiteColor);
}

.date {
	font-size: 9px;
	color: var(--font-color, $fontColor);
}

.content {
	padding-top: 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	&:first-child {
		padding-top: 0;
	}
}

.text-image {
	display: flex;
	align-items: center;

	p {
		font-size: 10px;
	}
}

.image {
	border-radius: 50%;
	height: 40px;
	width: 40px;
	min-width: 40px;
	overflow-y: hidden;
	margin-right: 20px;
}

.price {
	font-size: 16px;
	color: var(--white-color, $whiteColor);
	margin: 0 25px 0 0;
	white-space: nowrap;

	&:last-child {
		margin-right: 0;
	}
}

.notification-title {
	margin: 0 0 8px;
	font-size: 12px;
	font-weight: 600;
	color: var(--white-color, $whiteColor);

	&:last-child {
		margin-bottom: 0;
	}
}

.info {
	display: flex;
	align-items: center;
	margin-left: 15px;
}

@media($desktopM) {
	.info-actions {
		.button {
			width: initial;
		}
	}
}

@media($tabletL) {
	.price {
		margin-right: 0;
		margin-bottom: 5px;

		&:last-child {
			margin-bottom: 0;
		}
	}
	.info-actions {
		flex-direction: column;
	}
}

@media($tabletS) {
	/*.content {
		flex-direction: column;
		justify-content: center;
	}*/
	.text-image {
		width: 100%;
		margin-bottom: 20px;
		//justify-content: center;

		&:last-child {
			margin-bottom: 0;
		}
	}
	.info-actions {
		width: 100%;
		margin-left: 0;
		flex-direction: row;
		justify-content: center;

		.price {
			margin-right: 20px;
			margin-bottom: 0;

			&:last-child {
				margin-right: 0;
			}
		}
	}
}

@media($mobileM) {
	.panel-box {
		padding: 20px;
	}
	.content {
		padding-top: 15px;
	}
	.info-actions {
		flex-direction: column;

		.actions,
		.button {
			width: 100%;
		}

		.price {
			margin-right: 0;
			margin-bottom: 5px;
		}
	}
}
</style>